package com.eladfinish.bible.contest.ui.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.Raw
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.toImmutableList

data class MenuData<T>(
    val title: StringDesc = StringDesc.Raw(""),
    val items: List<T> = emptyList(),
)

@Composable
fun <T> MenuDialog(
    menuData: MenuData<T>,
    itemAsString: @Composable (T) -> String = { it.toString() },
    onItemClick: (Int, T) -> Unit,
    onDismiss: () -> Unit,
) {
    BasicDialogWithTitle(
        onDismiss = onDismiss,
        title = menuData.title.localized(),
        content = {
            AlternateRowColorsDialog(
                modifier = Modifier
                    .weight(1f),
                items = menuData.items.toImmutableList(),
                itemAsString = itemAsString,
                onItemClick = onItemClick,
            )
            DialogNegativeButtonInColumn(onClick = onDismiss)
        },
    )
}
